<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { statusUpdates } from "./utils/request";

export default {
  name: "App",
  data() {
    return {
      time: null
    };
  },
  methods: {
    statusUpdates() {
      statusUpdates().then(res => {});
    }
  },
  mounted() {
    this.statusUpdates();
    this.time = setInterval(() => {
      this.statusUpdates();
    }, 300000);
  },
  deactivated() {
    clearInterval(this.time);
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  font-family: SimHei;
}

ul,
li,
ol {
  list-style: none;
}

#stats {
  display: none;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-moz-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-o-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-ms-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.web-toast {
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 30px;
  line-height: 1;
  padding: 20px;
  border-radius: 3px;
  left: 50%;
  bottom: 12%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  z-index: 9999;
  white-space: nowrap;
}

.web-toast i {
  margin-right: 10px;
}

.fadeOut {
  animation: fadeOut 0.5s;
}

.fadeIn {
  animation: fadeIn 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue